import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import { INSERT_IMAGE_COMMAND } from './imageCommands';
import { ImageNode } from '../nodes/ImageNode';
import {
  $getRoot,
  $insertNodes,
  $createParagraphNode,
  $getSelection,
  $isRangeSelection
} from 'lexical';

export function ImagePlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      INSERT_IMAGE_COMMAND,
      (src: string) => {
       editor.update(() => {
  const root = $getRoot();
  
  const paragraphNode = $createParagraphNode();
  root.append(paragraphNode);
  paragraphNode.select();

  const imageNode = new ImageNode(src);
  $insertNodes([imageNode]);
});
        return true;
      },
      0
    );
  }, [editor]);

  return null;
}
